// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_shipping_intro = /** @type {(inputs: {}) => string} */ () => {
	return `We currently deliver throughout Cyprus. All orders are shipped via ACS Courier for fast and reliable delivery.`
};

const el_shipping_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Αυτή τη στιγμή πραγματοποιούμε παραδόσεις σε ολόκληρη την Κύπρο. Όλες οι παραγγελίες αποστέλλονται μέσω ACS Courier για γρήγορη και αξιόπιστη παράδοση.`
};

const ru_shipping_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Мы осуществляем доставку по всему Кипру. Все заказы отправляются курьерской службой ACS для быстрой и надёжной доставки.`
};

const he_shipping_intro = /** @type {(inputs: {}) => string} */ () => {
	return `אנו מבצעים משלוחים בכל רחבי קפריסין. כל ההזמנות נשלחות באמצעות שליחות ACS למשלוח מהיר ואמין.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_intro(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_intro", locale)
	if (locale === "en") return en_shipping_intro(inputs)
	if (locale === "el") return el_shipping_intro(inputs)
	if (locale === "ru") return ru_shipping_intro(inputs)
	if (locale === "he") return he_shipping_intro(inputs)
	return "shipping_intro"
};